import { createBlock } from 'factories/block';
import { InteractionProps } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import { getSId } from '../utils';
import { createEditableBtn } from './editableBtn';
import { createFeedbackBlock } from './feedback';

export type ImageInteractionProps = InteractionProps & {};

const contentForColumn = props => (i: number) => {
  return [
    () =>
      createBlock('TextEntryQuiz', [
        createBlock('Text'),
        createEditableBtn({
          label: 'Submit',
        }),

        createFeedbackBlock({}),
      ]),
    () =>
      createMediaBlock({
        child: 1,
      }),
  ][i];
};

export const createTextEntryQuizInteractionBlock = (props: any) => {
  // will fix this up later with the ' prop 'er definitions etc

  const { lockDown = 0, style } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(props), props.columnCount, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        lockDown,
      },
      meta: {
        subType: 'TextEntryQuiz',
        layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
          props.columnsReversed ? 'Reversed' : ''
        }`,
      },
    }
  );
};

export const interactionConfig = {};
